import * as React from 'react';

import PageSection from 'components/page/page-section';

import { LandingGetTheAppContainer } from './landing-get-the-app-container';

/**
 * Shown in place of LandingHeroBlockContainer for visitors arriving from social
 * links (JS-30122). Same download block as the bottom of the homepage. Top
 * spacing comes from styles/components/landing-download-hero.scss rather than
 * PageSection's padding="top", which is too small to clear the fixed header.
 */
export const LandingDownloadHeroContainer: React.FC = () => {
  return (
    <PageSection extraClass="landing-download-hero">
      <LandingGetTheAppContainer />
    </PageSection>
  );
};
